import { render } from "./kalio-badge.vue?vue&type=template&id=3e3f7415"
import script from "./kalio-badge.vue?vue&type=script&lang=js"
export * from "./kalio-badge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__